import React from 'react';

export const topQuestions = (
  <div>
    <h2 className="vads-u-margin-top--4">Top questions asked</h2>
    <p>You can get answers and resources for Ask VA’s top questions.</p>
    <va-accordion bordered>
      <va-accordion-item header="Why haven’t I received my VA disability pay?">
        <p className="vads-u-margin-top--0">
          If your decision notice shows at least a 10% disability rating, you
          should get your first payment within 15 days.
        </p>
        <p>
          <va-link
            href="/va-payment-history/"
            text="Check your VA payment history"
          />
        </p>
        <p>
          Here’s why you may not have received your disability compensation
          payment yet:
        </p>
        <p className="vads-u-font-weight--bold">
          1. You haven’t set up direct deposit
        </p>
        <p>
          You can add or change your direct deposit information in your VA.gov
          profile.
        </p>
        <p>
          <va-link
            href="/resources/direct-deposit-for-your-va-payments/"
            text="Learn about direct deposit for your VA payment"
          />
        </p>
        <p>
          <va-link
            href="/resources/how-to-change-direct-deposit-information-for-va-benefits/"
            text="Learn how to change direct deposit"
          />
        </p>
        <p className="vads-u-font-weight--bold">
          2. You need to update your address in your VA profile
        </p>
        <p>
          If you need to change your address you can do so online or by calling
          us at <va-telephone contact="8008271000" /> (
          <va-telephone contact="711" tty />
          ). We’re here Monday through Friday, 8:00 a.m. to 9:00 p.m. ET. Or you
          can submit VA Form 20-572.
        </p>
        <p>
          <va-link
            href="/change-address"
            text="Learn how to change your address in your VA profile"
          />
        </p>
        <p className="vads-u-margin-bottom--0">
          <va-link
            href="/forms/20-572/"
            text="Get VA Form 20-572 to download"
          />
        </p>
      </va-accordion-item>
      <va-accordion-item header="Am I eligible for other education benefits?">
        <p className="vads-u-margin-top--0">
          You can check if you’re eligible for other education benefits online.
          You can also compare education benefits.
        </p>
        <p>
          <va-link
            href="/education/eligibility/"
            text="Learn about GI Bill and other education benefit eligibility"
          />
        </p>
        <p>
          <va-link
            href="/resources/compare-va-education-benefits/"
            text="Compare VA education benefits"
          />
        </p>
        <p>
          If you think you’re eligible for other education benefits, we
          encourage you to apply online.
        </p>
        <p className="vads-u-margin-bottom--0">
          <va-link
            href="/education/apply-for-gi-bill-form-22-1990/introduction"
            text="Apply for VA education benefits"
          />
        </p>
      </va-accordion-item>
      <va-accordion-item header="How can I change my name and apply it to all VA records?">
        <p className="vads-u-margin-top--0">
          If your legal name has changed, you’ll need to contact your VA medical
          center, each VA program office that you receive direct benefit
          payments from, and the Defense Enrollment Eligibility Reporting System
          (DEERS) support office.
        </p>
        <p className="vads-u-margin-bottom--0">
          <va-link
            href="/resources/how-to-change-your-legal-name-on-file-with-va/"
            text="Learn how to change your legal name on file with VA"
          />
        </p>
      </va-accordion-item>
      <va-accordion-item header="What’s the status of my existing disability claim?">
        <p className="vads-u-margin-top--0">
          You can get the status of your disability claim using our online tool.
        </p>
        <p>
          <va-link
            href="/claim-or-appeal-status/"
            text="Check your claim, decision review, or appeal status"
          />
        </p>
        <p>
          You can also learn about what happens after you file your claim. And
          find out the average number of days it takes to process a VA
          disability claim.
        </p>
        <p className="vads-u-margin-bottom--0">
          <va-link
            href="/disability/after-you-file-claim/"
            text="Learn about the VA claim process"
          />
        </p>
      </va-accordion-item>
      <va-accordion-item header="Can I extend my GI Bill benefits past the expiration date?">
        <p className="vads-u-margin-top--0">
          You may qualify for a GI Bill extension if one of these is true:
        </p>
        <ul>
          <li>
            You served a later period of active duty of 90 consecutive days or
            more (meaning that after you applied for GI Bill benefits, you
            served 90 days or more without a break in service),{' '}
            <strong>or</strong>
          </li>
          <li>
            You have an illness or disability that prevented you from attending
            school, <strong>or</strong>
          </li>
          <li>
            You were held by a foreign government or power after your last
            discharge or release from active duty
          </li>
        </ul>
        <p>
          Your benefits expiration depends on when you were discharged from
          active duty.
        </p>
        <p className="vads-u-margin-bottom--0">
          <va-link
            href="/resources/getting-a-gi-bill-extension/"
            text="Learn more about getting a GI Bill extension"
          />
        </p>
      </va-accordion-item>
    </va-accordion>
  </div>
);
